import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad8DBlue8ARed = () => <CrossRoad coords="2139.000000, 829.694374"/>;
export default CrossRoad8DBlue8ARed;
